/*
__/\\\\\\\\\\\\\\\__/\\\\\\\\\\\\\\\_____/\\\\\\\\\____        
 _\///////\\\/////__\///////\\\/////____/\\\\\\\\\\\\\__       
  _______\/\\\_____________\/\\\________/\\\/////////\\\_      
   _______\/\\\_____________\/\\\_______\/\\\_______\/\\\_     
    _______\/\\\_____________\/\\\_______\/\\\\\\\\\\\\\\\_    
     _______\/\\\_____________\/\\\_______\/\\\/////////\\\_   
      _______\/\\\_____________\/\\\_______\/\\\_______\/\\\_  
       _______\/\\\_____________\/\\\_______\/\\\_______\/\\\_ 
        _______\///______________\///________\///________\///__
            
            COPYRIGHT TACTICAL TRANSPORTATION ADVISORS, INC. 
            ALL RIGHTS RESERVED.
*/

import React from 'react';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import TTABackground from './components/TTABackground';
import Cookies from 'universal-cookie';
import './App.css';
import 'draft-js/dist/Draft.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faInfoCircle, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import EmployeeOnboarding from './views/EmployeeOnboarding/EmployeeOnboarding';

type AppState = {
  alertType: 'warning' | 'danger' | 'info' | 'success';
  alertTitle: string;
  showAlert: boolean;
  auth: Auth;
  isLoading: boolean;
  notifications: any[];
  initializedCobrowse: boolean;
};

type Auth = {
  userIdentifier: number | undefined;
  clientUserIdentifier: number | undefined;
  adminUserIdentifier: number | undefined;
};

export default class App extends React.Component<{}, AppState> {
  constructor(props: any) {
    super(props);
    this.state = {
      alertType: 'warning',
      alertTitle: '',
      showAlert: false,
      auth: { userIdentifier: undefined, clientUserIdentifier: undefined, adminUserIdentifier: undefined },
      isLoading: true,
      notifications: [],
      initializedCobrowse: false,
    };

    this.alert = this.alert.bind(this);
    this.dismissAlert = this.dismissAlert.bind(this);

    AppGlobals.alert = this.alert;
  }

  alert(type: 'warning' | 'danger' | 'info' | 'success', title: string) {
    this.setState({ alertType: type, alertTitle: title, showAlert: true });
  }

  dismissAlert() {
    this.setState({ showAlert: false });
  }

  initializeCobrowse() {
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.innerHTML = `(function(w,t,c,p,s,e){p=new Promise(function(r){w[c]={client:function(){if(!s){
        s=document.createElement(t);s.src='https://js.cobrowse.io/CobrowseIO.js';s.async=1;s.crossOrigin='anonymous';
        e=document.getElementsByTagName(t)[0];e.parentNode.insertBefore(s,e);s.onload=function()
        {r(w[c]);};}return p;}};});})(window,'script','CobrowseIO');

        CobrowseIO.license = "h-pVfTMTlbqNvQ";
        CobrowseIO.customData = {
            user_id: "User",
            user_name: "User",
            device_name: "MTR - User"
        };
        CobrowseIO.client().then(function(){
            CobrowseIO.start();
        });`;
    document.body.appendChild(s);
  }

  render() {
    return (
      <Router>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            height: '100vh',
            textAlign: 'center',
            position: 'relative',
            backgroundColor: 'var(--bs-primary)',
          }}
        >
          <TTABackground style={undefined} />
          <div
            style={{
              position: 'absolute',
              height: '100vh',
              width: '100vw',
              display: 'flex',
              flexDirection: 'column',
              textAlign: 'start',
            }}
          >
            <div className="hidden-scrollbar" style={{ overflowY: 'scroll', flex: 1, position: 'relative' }}>
              <Switch>
                <Route path="/employee-onboarding/:onboardingToken" component={EmployeeOnboarding} />
              </Switch>
            </div>
          </div>
        </div>
        <Modal show={this.state.showAlert} onHide={this.dismissAlert}>
          <Modal.Body style={{ padding: 8 }}>
            {
              <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                <FontAwesomeIcon
                  style={{
                    color:
                      this.state.alertType == 'danger'
                        ? 'red'
                        : this.state.alertType == 'warning'
                        ? 'gold'
                        : this.state.alertType == 'info'
                        ? 'var(--bs-primary)'
                        : 'green',
                  }}
                  icon={
                    this.state.alertType == 'info'
                      ? faInfoCircle
                      : this.state.alertType === 'success'
                      ? faCheck
                      : faTriangleExclamation
                  }
                />
                <div style={{ flex: 1, overflow: 'hidden' }}>
                  <span style={{ overflowWrap: 'break-word', wordWrap: 'break-word' }}>{this.state.alertTitle}</span>
                </div>
              </div>
            }
          </Modal.Body>
        </Modal>
      </Router>
    );
  }
}

export class AppGlobals {
  static alert: (type: 'warning' | 'danger' | 'info' | 'success', title: string) => void;
  static checkAuthentication: () => void;
  static CookieMonster: Cookies = new Cookies();
}
